import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popup-header popup-header--products" }
const _hoisted_2 = { class: "popup-header-meta" }
const _hoisted_3 = { class: "status-chip status-chip--active" }
const _hoisted_4 = { class: "details-container" }
const _hoisted_5 = { class: "stats-grid" }
const _hoisted_6 = { class: "stat-card stat-card--quantity" }
const _hoisted_7 = { class: "stat-content" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { class: "stat-card stat-card--price" }
const _hoisted_10 = { class: "stat-content" }
const _hoisted_11 = { class: "stat-value" }
const _hoisted_12 = { class: "info-sections-grid" }
const _hoisted_13 = { class: "info-column" }
const _hoisted_14 = { class: "info-section-card" }
const _hoisted_15 = { class: "info-list" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = { class: "value highlight" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "info-item" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "info-column" }
const _hoisted_23 = { class: "info-section-card" }
const _hoisted_24 = { class: "info-list" }
const _hoisted_25 = { class: "info-item" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "info-item" }
const _hoisted_28 = { class: "value success" }
const _hoisted_29 = { class: "info-item" }
const _hoisted_30 = { class: "value highlight" }
const _hoisted_31 = { class: "system-meta-card" }
const _hoisted_32 = { class: "meta-row" }
const _hoisted_33 = { class: "meta-item" }
const _hoisted_34 = { class: "meta-item" }
const _hoisted_35 = {
  ref: "popupBody",
  class: "popup-body-simple popup-body-modern"
}
const _hoisted_36 = { class: "form-content form-content-modern" }
const _hoisted_37 = {
  class: "dropdown-grid-container",
  style: {"height":"350px"}
}
const _hoisted_38 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_39 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_40 = { class: "footer-right" }
const _hoisted_41 = { class: "popup-body-modern" }
const _hoisted_42 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_43 = {
  class: "footer-right",
  style: {"margin-top":"20px","text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_dx_button = _resolveComponent("dx-button")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxFormItemGrid = _resolveComponent("DxFormItemGrid")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxTotalItem = _resolveComponent("DxTotalItem")!
  const _component_DxSummary = _resolveComponent("DxSummary")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxForm = _resolveComponent("DxForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": {
      store: _ctx.dsSalesProducts,
      filter: ['OfertaID', '=', _ctx.offerId]
    },
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-row-lines": true,
      "show-column-lines": false,
      allowMerging: 'Cells',
      height: "100%",
      class: "grid theme-dependent",
      onExporting: _ctx.onExporting,
      onInitNewRow: _ctx.onInitNewRow,
      onRowRemoving: _ctx.onRowRemoving,
      onRowInserted: _ctx.onRowInserted,
      "keyboard-navigation": { enterKeyAction: 'save', enterKeyDirection: 'none', editOnKeyPress: true }
    }, {
      produsCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxDropDownBox, {
          "data-source": _ctx.dsProduse,
          "value-expr": "Id",
          "display-expr": _ctx.displayProdus,
          value: data.value,
          opened: _ctx.isProdusDdbOpen,
          "onUpdate:opened": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isProdusDdbOpen) = $event)),
          "show-clear-button": true,
          "content-template": "produsGridContent",
          placeholder: "Selectează produs...",
          width: "1200px"
        }, {
          produsGridContent: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsProduse,
              "key-expr": "Id",
              height: "100%",
              width: "1500px",
              onSelectionChanged: (e) => _ctx.onProdusSelectionChanged(e, data)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, { mode: "single" }),
                _createVNode(_component_DxFilterRow, { visible: true }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Cod",
                  caption: "Cod",
                  width: "120"
                }),
                _createVNode(_component_DxColumn, { "data-field": "Nume" })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _: 2
        }, 1032, ["data-source", "display-expr", "value", "opened"])
      ]),
      saleCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxDropDownBox, {
          "data-source": _ctx.dsSales,
          "value-expr": "ID",
          "display-expr": _ctx.display,
          value: data.value,
          opened: _ctx.isSaleDdbOpen,
          "onUpdate:opened": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isSaleDdbOpen) = $event)),
          "show-clear-button": true,
          "content-template": "saleGridContent"
        }, {
          saleGridContent: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsSales,
              "key-expr": "ID",
              columns: ['Titlu'],
              height: "100%",
              onSelectionChanged: e => {
              const id = e.selectedRowKeys?.[0] ?? null;
              data.setValue(id);
              _ctx.isSaleDdbOpen = false;
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, { mode: "single" })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _: 2
        }, 1032, ["data-source", "display-expr", "value", "opened"])
      ]),
      pretListaValutaCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxDropDownBox, {
          "data-source": _ctx.dsPretListaValuta,
          "value-expr": "Id",
          "display-expr": _ctx.displayValuta,
          value: data.value,
          opened: _ctx.isValutaDdbOpen,
          "onUpdate:opened": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isValutaDdbOpen) = $event)),
          "show-clear-button": true,
          "content-template": "pretValutaGridContent",
          placeholder: "RON"
        }, {
          pretValutaGridContent: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsPretListaValuta,
              "key-expr": "Id",
              columns: ['Simbol'],
              height: "100%",
              onSelectionChanged: e => {
                const id = e.selectedRowKeys?.[0] ?? null;
                data.setValue(id);
                _ctx.isValutaDdbOpen = false;
              }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, { mode: "single" })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _: 2
        }, 1032, ["data-source", "display-expr", "value", "opened"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxScrolling, { mode: 'virtual' }),
        _createVNode(_component_DxColumnChooser, { enabled: true }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxLoadPanel, { "show-pane": false }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Cauta Produsul",
          "search-visible-columns-only": true
        }),
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": true,
          formats: ['xlsx', 'pdf']
        }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, {
              location: "before",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_dx_button, {
                    icon: "plus",
                    width: "30px",
                    height: "30px",
                    onClick: _ctx.onAddClick,
                    disabled: _ctx.isLocked,
                    hint: "Adaugă produs existent"
                  }, null, 8, ["onClick", "disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_dx_button, {
                    icon: "plus",
                    width: "30px",
                    height: "30px",
                    type: "success",
                    hint: "Adaugă produs nou",
                    onClick: _ctx.onAddNewProdus,
                    disabled: _ctx.isLocked
                  }, null, 8, ["onClick", "disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_DxButton, {
                    icon: "refresh",
                    width: "30px",
                    height: "30px",
                    onClick: _ctx.onRefreshClick
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "exportButton",
              width: "30px",
              height: "30px"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "columnChooserButton",
              width: "10px",
              height: "10px"
            }),
            _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
          ]),
          _: 1
        }),
        _createVNode(_component_DxTexts, {
          "group-continued-message": "Continuat de pe pagina anterioara",
          "group-continues-message": "Continuat pe pagina urmatoare"
        }),
        _createVNode(_component_DxEditing, {
          allowUpdating: !_ctx.isLocked,
          allowDeleting: !_ctx.isLocked,
          mode: "row",
          "new-row-position": "last"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 700,
              height: 430
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.successButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, {
              "col-span": 4,
              "col-count": 4
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItemGrid, {
                  "col-span": 4,
                  "col-count": 4,
                  "item-type": "group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItemGrid, {
                      "data-field": "ProdusID",
                      label: { text: 'Produs' },
                      "col-span": 3
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Cantitate",
                      editorType: "dxNumberBox",
                      "editor-options": { format: '#0.00', showSpinButtons: true, width: '100%' },
                      "col-span": 1
                    }),
                    _createVNode(_component_DxFormItemGrid, {
                      "data-field": "PretListaValutaID",
                      label: { text: 'Valută' }
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Pret",
                      editorType: "dxNumberBox",
                      "editor-options": { format: '#0.00', showSpinButtons: true, width: '100%' }
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "DiscountProc",
                      editorType: "dxNumberBox",
                      label: { text: 'Discount' },
                      "editor-options": { format: '#0.00', showSpinButtons: true, width: '100%' }
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "PretSpecial",
                      editorType: "dxNumberBox",
                      "editor-options": { format: '#0.00', showSpinButtons: true, width: '100%' }
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Observatii",
                      "col-span": 4,
                      "editor-options": { width: '100%', height: '100px' },
                      editorType: "dxTextArea"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["allowUpdating", "allowDeleting"]),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          "storage-key": "CrmSalesProducts"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ProdusID",
          "edit-cell-template": 'produsCellEditor',
          caption: "Articol",
          "calculate-display-value": _ctx.calculateProductDisplayValue,
          fixed: true,
          "fixed-position": "left"
        }, null, 8, ["calculate-display-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "Produs.Cod",
          caption: "Cod Produs",
          allowEditing: false,
          "fixed-position": "left"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Produs.Nume",
          caption: "Nume Produs",
          allowEditing: false,
          "fixed-position": "left"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Sale.Titlu",
          caption: "Oportunitate",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "SaleID",
          visible: false,
          "edit-cell-template": 'saleCellEditor'
        }),
        _createVNode(_component_DxColumn, { "data-field": "Cantitate" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxRequiredRule, { message: "Cantitatea este obligatorie" })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Pret",
          "set-cell-value": _ctx.setPretValue,
          format: '#,##0.00 '
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxRequiredRule, { message: "Pretul este obligatoriu" })
          ]),
          _: 1
        }, 8, ["set-cell-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "DiscountProc",
          "set-cell-value": _ctx.setDiscountValue,
          caption: "Discount %"
        }, null, 8, ["set-cell-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "PretSpecial",
          "set-cell-value": _ctx.setPretSpecialValue,
          caption: "Preț Special",
          format: '#,##0.00 '
        }, null, 8, ["set-cell-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "PretListaValutaID",
          "edit-cell-template": 'pretListaValutaCellEditor',
          caption: "Valută",
          "calculate-display-value": _ctx.calculateValutaDisplayValue
        }, null, 8, ["calculate-display-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "ValoareTotala",
          caption: "Valoare Totală (RON)",
          "calculate-cell-value": _ctx.calculateTotalValue,
          format: '#,##0.00 ',
          "allow-editing": false
        }, null, 8, ["calculate-cell-value"]),
        _createVNode(_component_DxColumn, {
          type: "buttons",
          buttons: [
        {
          hint: 'Vezi detalii',
          icon: 'info',
          onClick: _ctx.onViewDetails
        },
        {
          name: 'edit',
          visible: !_ctx.isLocked
        },
        {
          name: 'delete',
          visible: !_ctx.isLocked
        }
      ]
        }, null, 8, ["buttons"]),
        _createVNode(_component_DxSummary, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxTotalItem, {
              column: "Cantitate",
              "summary-type": "sum",
              "display-format": "Total: {0}"
            }),
            _createVNode(_component_DxTotalItem, {
              column: "ValoareTotala",
              "summary-type": "sum",
              "value-format": '#,##0.00 ',
              "display-format": "Total: {0} RON"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source", "onExporting", "onInitNewRow", "onRowRemoving", "onRowInserted"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isProductsDetailsVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isProductsDetailsVisible) = $event)),
      "drag-enabled": false,
      "hide-on-outside-click": true,
      "show-close-button": true,
      width: 750,
      height: 600
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-product" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-subtitle" }, "Componente Oportunitate CRM")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.selectedProduct.Disponibilitate || 'Activ'), 1)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxScrollView, {
          width: "100%",
          height: "100%",
          class: "details-scroll-view"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stat-icon dx-icon-box" }, null, -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-label" }, "Cantitate", -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.selectedProduct.Cantitate || 0) + " buc", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "stat-icon dx-icon-money" }, null, -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "stat-label" }, "Preț ", -1)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.selectedProduct.Pret), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-info section-icon" }),
                      _createElementVNode("span", null, "Informații Articol")
                    ], -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Nume Produs", -1)),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.selectedProduct.Produs?.Nume || _ctx.selectedProduct.ProdusNume || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", null, "Cod Produs", -1)),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.selectedProduct.Produs?.Cod || _ctx.selectedProduct.ProdusCod || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", null, "Preț", -1)),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.selectedProduct.Pret || '-'), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-cart section-icon" }),
                      _createElementVNode("span", null, "Date Comerciale")
                    ], -1)),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", null, "Valuta", -1)),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.calculateValutaDisplayValue(_ctx.selectedProduct)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", null, "Preț Special ", -1)),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.selectedProduct.PretSpecial), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", null, "Discount (%)", -1)),
                        _createElementVNode("div", _hoisted_30, "-" + _toDisplayString(_ctx.selectedProduct.DiscountProc || 0) + "%", 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "dx-icon-user meta-icon" }, null, -1)),
                    _createElementVNode("span", null, "Creat la " + _toDisplayString(_ctx.formatDate(_ctx.selectedProduct.DataCreare, true)), 1)
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "meta-separator" }, null, -1)),
                  _createElementVNode("div", _hoisted_34, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "dx-icon-edit meta-icon" }, null, -1)),
                    _createElementVNode("span", null, "Modificat la " + _toDisplayString(_ctx.formatDate(_ctx.selectedProduct.DataModificare, true)), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 750,
      height: 480
    }, {
      title: _withCtx(() => [...(_cache[26] || (_cache[26] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare produs"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează informațiile în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nouă ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_DxForm, {
              formData: _ctx.formData,
              "col-span": 4,
              "col-count": 4,
              onFieldDataChanged: _ctx.onFieldDataChanged
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Produs' },
                  "col-span": 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Produs' este obligatoriu" }),
                    _createVNode(_component_DxDropDownBox, {
                      value: _ctx.sProdus,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sProdus) = $event)),
                      "data-source": _ctx.dsProduse,
                      "value-expr": "Id",
                      "display-expr": _ctx.displayProdus,
                      "show-clear-button": true,
                      placeholder: "Selectează produs",
                      "content-template": "produsAddPopupContent"
                    }, {
                      produsAddPopupContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsProduse,
                            "hover-state-enabled": true,
                            height: 280,
                            "remote-operations": true,
                            onRowClick: _ctx.onProdusRowClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxColumn, {
                                "data-field": "Nume",
                                caption: "Denumire produs"
                              }),
                              _createVNode(_component_DxColumn, {
                                "data-field": "Cod",
                                caption: "Cod produs",
                                width: "150"
                              }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxScrolling, { mode: "virtual" }),
                              _createVNode(_component_DxGridToolbar, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxButton, {
                                        icon: "plus",
                                        type: "success",
                                        height: "25px",
                                        width: "25px",
                                        onClick: _ctx.onAddNewProdus
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "onRowClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["value", "data-source", "display-expr"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  dataField: "Cantitate",
                  editorType: "dxNumberBox",
                  "editor-options": { format: '#0.00', showSpinButtons: true, width: '100%' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Cantitate' este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  dataField: "Pret",
                  editorType: "dxNumberBox",
                  "editor-options": { format: '#0.00', showSpinButtons: true, width: '100%' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Pret' este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  dataField: "DiscountProc",
                  editorType: "dxNumberBox",
                  "editor-options": { format: '#0.00', showSpinButtons: true, width: '100%' }
                }),
                _createVNode(_component_DxFormItem, {
                  dataField: "PretSpecial",
                  editorType: "dxNumberBox",
                  "editor-options": { format: '#0.00', showSpinButtons: true, width: '100%' }
                }),
                _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      value: _ctx.sValute,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sValute) = $event)),
                      "data-source": _ctx.dsPretListaValuta,
                      "display-expr": "Simbol",
                      "value-expr": "Id",
                      "show-clear-button": true,
                      "content-template": "valutaAddPopupContent"
                    }, {
                      valutaAddPopupContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsPretListaValuta,
                            columns: ['Simbol'],
                            "hover-state-enabled": true,
                            height: 280,
                            "remote-operations": true,
                            onRowClick: _ctx.onValuteRowClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxScrolling, { mode: "virtual" })
                            ]),
                            _: 1
                          }, 8, ["data-source", "onRowClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["value", "data-source"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  dataField: "Observatii",
                  "col-span": 4,
                  "editor-options": { width: '100%', height: '100px' },
                  editorType: "dxTextArea"
                })
              ]),
              _: 1
            }, 8, ["formData", "onFieldDataChanged"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onSaveAdd,
                disabled: _ctx.isLocked
              }, null, 8, ["onClick", "disabled"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ])
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isProdusModalVisible,
      width: 750,
      height: 480,
      "show-title": true,
      title: "Adăugare Produs",
      onHiding: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isProdusModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[27] || (_cache[27] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare produs nou"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile produsului ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_DxForm, {
            "form-data": _ctx.newProductData,
            "col-count": 2,
            "col-span": 2,
            onFieldDataChanged: _ctx.onNewProductFieldDataChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, {
                "data-field": "Cod",
                label: { text: 'Cod Produs' },
                "col-span": 2,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Codul produsului este obligatoriu" })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Nume",
                label: { text: 'Descriere Produs' },
                "col-span": 2,
                "col-count": 2,
                "editor-options": { height: 80 },
                "editor-type": "dxTextArea"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Descrierea produsului este obligatorie" })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Stocabil",
                "editor-type": "dxCheckBox",
                label: { text: 'Produs' }
              }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Serviciu",
                "editor-type": "dxCheckBox"
              })
            ]),
            _: 1
          }, 8, ["form-data", "onFieldDataChanged"]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                onClick: _ctx.onSaveNewProduct,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined",
                disabled: _ctx.isLocked
              }, null, 8, ["onClick", "disabled"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isProdusModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}